import React from "react";
import "./AddressPopupContent.css";

const AddressPopupContent = ({ item, handleOpenAddressPopup, addresses }) => {
  console.log(addresses);
  return (
    <div className="popup-container">
      <div className="popup-body">
        <button
          className="d-flex justify-content-center align-items-center ml-auto btn btn-danger popup-button"
          onClick={handleOpenAddressPopup}
        >
          X
        </button>
        {item && !addresses && (
          <AddressDivInPopup
            addressType={item?.address_str}
            name={
              item?.shipping_address?.kanji_first_name +
              " " +
              item?.shipping_address?.kanji_last_name
            }
            postalCode={item?.shipping_address?.postal_code}
            address={`${item?.shipping_address?.Building_number} ${item?.shipping_address?.prefecture}, ${item?.shipping_address?.municipality}, ${item?.shipping_address?.postal_code}`}
            phoneNumber={item?.shipping_address?.phone}
          />
        )}
        {!item &&
          addresses &&
          Object.keys(addresses).length > 0 &&
          Object.keys(addresses).map((addressField, i) => {
            return (
              <div key={i}>
                <AddressDivInPopup
                  addressType={i === 0 ? "会員様住所" : "別送住所" + i}
                  name={
                    addresses[addressField]?.kanji_first_name +
                    " " +
                    addresses[addressField]?.kanji_last_name
                  }
                  postalCode={addresses[addressField]?.postal_code}
                  address={`${addresses[addressField]?.Building_number} ${addresses[addressField]?.prefecture}, ${addresses[addressField]?.municipality}, ${addresses[addressField]?.postal_code}`}
                  phoneNumber={addresses[addressField]?.phone}
                />
              </div>
            );
          })}
        <div className="popup-address-notice mt-4">
          住所は確定しているためこの画面から住所変更はできません。
        </div>
        {!item && (
          <button
            className="btn visit-reg-btn"
            onClick={handleOpenAddressPopup}
          >
            戻る
          </button>
        )}
      </div>
    </div>
  );
};

const AddressDivInPopup = ({
  name,
  postalCode,
  address,
  phoneNumber,
  addressType,
}) => {
  return (
    <div className="popup-address-container">
      <h5 className="popup-address-header">{addressType}</h5>
      <div className="popup-address-info">
        <div>{name}</div>
        <div>{postalCode}</div>
        <div>{address}</div>
        <div>{phoneNumber}</div>
      </div>
    </div>
  );
};

export default AddressPopupContent;
